<section class="youtube-section">
  <div class="youtube-header">
    <p class="youtube-label">Featured</p>
  </div>

  @if (youtubeEmbedUrl) {
    <div class="youtube-wrapper">
      <iframe
        [src]="youtubeEmbedUrl"
        title="McDonald's Featured Video"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen>
      </iframe>
    </div>
  }
</section>